import React from 'react';
import styled from '@emotion/styled';

const BackingViewImage = styled.svg`
 margin-bottom: -10px;
`;

export default (arr, section) => (
  <BackingViewImage width="121px" height="155px" viewBox="0 0 121 155">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id={section}>
        <stop stopColor={arr[0]} offset="0%" />
        <stop stopColor={arr[1]} offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Desktop" transform="translate(-377.000000, -236.000000)" fill={`url(#${section})`} fillRule="nonzero">
        <g id="Group-2" transform="translate(63.000000, 173.000000)">
          <g id="Group" transform="translate(311.000000, -55.000000)">
            <g id="Group-3">
              <rect id="Rectangle-2" transform="translate(190.553256, 168.965300) rotate(54.000000) translate(-190.553256, -168.965300) " x="110.65019" y="-8.51850218" width="159.806133" height="354.967604" rx="10" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BackingViewImage>
);
